/**
 * The bits of the public document page that are not React.
 *
 * Small on purpose: the status label is read by both the document header and
 * the summary rail, and one copy is what stops the two from ever printing a
 * different word for the same document.
 */
import type { PublicDoc } from "../../lib/publicDoc";

/**
 * Which catalogue a kind's status labels live in.
 *
 * An invoice status (`sent`, `paid`, `overdue`) and an offer status
 * (`accepted`, `declined`, `expired`) are two different vocabularies that
 * happen to share a field name, so the kind picks the catalogue.
 */
export function statusLabelKey(doc: PublicDoc): string {
  return doc.type === "invoice"
    ? `portal.invoiceStatus.${doc.status}`
    : `portal.estimateStatus.${doc.status}`;
}
